import { useState } from 'react';
import IPDService from '../services/ipdService';

const ipdService = new IPDService();

export const useDeleteTimelineEntry = () => {
    const [loading, setLoading] = useState(false);

    const deleteEntry = async (entryId) => {
        setLoading(true);
        try {
            const response = await ipdService.deleteTimelineEntry(entryId);
            return response;
        } catch (error) {
            throw error;
        } finally {
            setLoading(false);
        }
    };

    return {
        deleteEntry,
        loading
    };
}; 